import {
    anObjectReferralCRUD,
    entityCRUD,
    prescriptionCRUD,
    resolutionActCRUD,
    resolutionCRUD,
} from "../http";
import { orderTypeIds } from "../models/orderTypeIds";

async function loadPurposeOfSelection(doc) {
    if (!doc) return null;
    let purpose = doc.purpose ?? doc.purposeOfSelection ?? doc.PurposeOfSelection ?? null;
    const purposeId =
        doc.purposeId ??
        purpose?.id ??
        doc.purposeOfSelectionId ??
        doc.PurposeOfSelectionId ??
        null;
    if (purposeId && !purpose?.name) {
        try {
            purpose = await entityCRUD("purposeOfSelection").get(purposeId);
        } catch {
            // keep whatever we already have
        }
    }
    return purpose;
}

async function findResolutionIdByAct(actId) {
    if (!actId) return null;
    try {
        const row = await resolutionActCRUD.firstOrDefault({
            paging: { take: 1 },
            filter: {
                actId: { operand1: actId, operator: "equals" },
            },
        });
        return row?.resolutionId ?? null;
    } catch {
        return null;
    }
}

/**
 * Цель отбора с постановления / предписания, связанных с протоколом.
 * На постановлении «Цель отбора» хранится отдельно от акта и заявки.
 */
export async function fetchKsekDocumentPurpose({
    actId,
    objectReferralId,
    referralId,
} = {}) {
    let objectReferral = null;
    let resolutionId = null;
    let prescriptionId = null;

    if (objectReferralId) {
        try {
            objectReferral = await anObjectReferralCRUD.get(objectReferralId);
            resolutionId =
                objectReferral?.resolutionId ?? objectReferral?.ResolutionId ?? null;
            prescriptionId =
                objectReferral?.prescriptionId ?? objectReferral?.PrescriptionId ?? null;
        } catch {
            objectReferral = null;
        }
    }

    const actIdsToTry = [
        actId,
        objectReferral?.actId,
        referralId,
    ].filter(Boolean);

    for (let i = 0; i < actIdsToTry.length && !resolutionId; i++) {
        resolutionId = await findResolutionIdByAct(actIdsToTry[i]);
    }

    try {
        if (resolutionId) {
            const resolution = await resolutionCRUD.get(resolutionId);
            return {
                purpose: await loadPurposeOfSelection(resolution),
                orderType: orderTypeIds.government,
            };
        }
        if (prescriptionId) {
            const prescription = await prescriptionCRUD.get(prescriptionId);
            return {
                purpose: await loadPurposeOfSelection(prescription),
                orderType: orderTypeIds.government,
            };
        }
    } catch {
        return { purpose: null, orderType: null };
    }

    return { purpose: null, orderType: null };
}
